import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";

export default function BlockQuoteNode(
    props: RenderElementProps,
): React.ReactElement {
    const {attributes, children} = props;

    return (
        <Body {...attributes} style={styles.quote} tag="blockquote">
            {children}
        </Body>
    );
}

const styles = StyleSheet.create({
    quote: {
        paddingInlineStart: spacing.small_12,
        borderInlineStart: `${spacing.xxxSmall_4}px solid ${semanticColor.core.border.neutral.subtle}`,
        marginBlockEnd: spacing.medium_16,
        display: "block",
    },
});
